import { getField, updateField } from 'vuex-map-fields'
import apiAxios from '../../services/apiAxios'
import moment from 'moment'
import helpers from '../../mixins/helpers'

const state = {
  retenciones: [],
  /* Info de paginación */
  paginaActual: 1,
  totalPaginas: 1,
  registrosPorPagina: 10,
  totalRegistros: 0,
  /* Filtro */
  fechaDesde: moment(new Date()).add(-15, 'days').format('YYYY-MM-DD'),
  fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
  cliente: null,
  proveedor: null,
  retencionTipo: null,
  retencionRegimen: null,
  incluirRetencionesLiquidadas: false,

  rptRetenciones: [],
  retencionesCartera: [],
  retencionesCarteraSeleccionadas: [],
}

const mutations = {
  updateField,

  INICIALIZAR_OPCIONES(state) {
    state.retenciones = []
    /* Opciones de filtro y paginacion */
    state.paginaActual = 1
    state.registrosPorPagina = 10
    state.totalRegistros = 0
    state.totalPaginas = 0

    state.fechaDesde = moment(new Date()).add(-15, 'days').format('YYYY-MM-DD')
    state.fechaHasta = moment(new Date()).format('YYYY-MM-DD')
    state.cliente = null
    state.proveedor = null
    state.retencionTipo = null
    state.retencionRegimen = null
    state.incluirRetencionesLiquidadas = false
  },

  INICIALIZAR(state) {
    state.retenciones = []
  },
  SET_RETENCIONES(state, retenciones) {
    state.retenciones = retenciones
  },
  SET_PAGINATION(state, params) {
    state.paginaActual = params.paginaActual
    state.totalPaginas = params.totalPaginas
    state.registrosPorPagina = params.registrosPorPagina
    state.totalRegistros = params.totalRegistros
  },

  INICIALIZAR_RPT(state) {
    state.rptRetenciones = []
  },
  SET_RPT(state, rptRetenciones) {
    state.rptRetenciones = rptRetenciones
  },

  INICIALIZAR_RETENCIONES_CARTERA(state) {
    state.retencionesCartera = []
  },
  SET_RETENCIONES_CARTERA(state, retenciones) {
    state.retencionesCartera = retenciones.map((retencion) => ({
      ...retencion,
      selected: false,
    }))
  },
  SET_RETENCIONES_CARTERA_SELECCIONADAS(state, retencionesSeleccionadas) {
    if (retencionesSeleccionadas.length != 0) {
      state.retencionesCartera.forEach(
        (retencion) =>
          (retencion.selected = retencionesSeleccionadas.some((rc) => rc.id == retencion.id) ? true : false)
      )

      /* Ordenamos los cheques, primero los seleccionados */
      state.retencionesCartera.sort(function (prev, current) {
        if (prev.selected) {
          if (current.selected) {
            if (prev.fechaComprobante > current.fechaComprobante) {
              return 1
            } else {
              return -1
            }
          } else {
            return -1
          }
        } else {
          if (current.selected) {
            return 1
          } else {
            if (prev.fechaComprobante > current.fechaComprobante) {
              return 1
            } else {
              return -1
            }
          }
        }
      })
    }
  },
}

const actions = {
  inicializarOpciones({ commit }) {
    commit('INICIALIZAR_OPCIONES')
  },

  getRetenciones: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR')

      let queryString =
        `?fechaDesde=${moment(state.fechaDesde).format('YYYY-MM-DD')}` +
        `&fechaHasta=${moment(state.fechaHasta).format('YYYY-MM-DD')}` +
        `&pageSize=${state.registrosPorPagina}` +
        `&pageNumber=${state.paginaActual}`

      if (state.cliente) {
        if (state.cliente.id != 0) {
          queryString += '&clienteId=' + state.cliente.id
        }
      }
      if (state.proveedor) {
        if (state.proveedor.id != 0) {
          queryString += '&proveedorId=' + state.proveedor.id
        }
      }
      if (state.retencionTipo) {
        if (state.retencionTipo.id != 0) {
          queryString += '&retencionTipoId=' + state.retencionTipo.id
        }
      }
      if (state.retencionRegimen) {
        if (state.retencionRegimen.id != 0) {
          queryString += '&retencionRegimenId=' + state.retencionRegimen.id
        }
      }
      if (/true/i.test(state.incluirRetencionesLiquidadas)) {
        queryString += '&incluirRetencionesLiquidadas=true'
      }

      apiAxios
        .get('retencionesclientes' + queryString)
        .then((res) => {
          if (res.headers.pagination) {
            const pagination = JSON.parse(res.headers.pagination)
            let params = {
              paginaActual: pagination.currentPage,
              registrosPorPagina: pagination.itemsPerPage,
              totalRegistros: pagination.totalItems,
              totalPaginas: pagination.totalPages,
            }
            commit('SET_PAGINATION', params)
          }

          commit('SET_RETENCIONES', res.data)
          resolve()
        })
        .catch((error) => reject(helpers.methods.apiError(error)))
    })
  },
  getRptRetenciones: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_RPT')

      let queryString =
        '?' +
        'fechaDesde=' +
        moment(params.fechaDesde).format('YYYY-MM-DD') +
        '&fechaHasta=' +
        moment(params.fechaHasta).format('YYYY-MM-DD')

      if (params.retencionTipoId) {
        if (params.retencionTipoId != 0) {
          queryString += '&retencionTipoId=' + params.retencionTipoId
        }
      }

      apiAxios
        .get('retencionesclientes/export' + queryString)
        .then((res) => {
          commit('SET_RPT', res.data)
          resolve()
        })
        .catch((error) => reject(helpers.methods.apiError(error)))
    })
  },
  getRetencionesCartera: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_RETENCIONES_CARTERA')

      let queryString = ''
      if (params) {
        if (params.impuestoOrganismoId) {
          if (params.impuestoOrganismoId != 0) {
            queryString = '?impuestoOrganismoId= ' + params.impuestoOrganismoId
          }
        }
      }

      apiAxios
        .get('retencionesclientes/cartera' + queryString)
        .then((res) => {
          commit('SET_RETENCIONES_CARTERA', res.data)

          if (params.retencionesSeleccionadas) {
            if (params.retencionesSeleccionadas != null) {
              commit('SET_RETENCIONES_CARTERA_SELECCIONADAS', params.retencionesSeleccionadas)
            }
          }

          resolve()
        })
        .catch((error) => reject(helpers.methods.apiError(error)))
    })
  },
}

const getters = {
  getField,

  retencionesCarteraSeleccionadas(state) {
    let seleccionadas = []
    if (state.retencionesCartera.length != 0) {
      seleccionadas = state.retencionesCartera.filter((rc) => /true/i.test(rc.selected) == Boolean(true))
    }
    return seleccionadas
  },
  rptRetenciones(state) {
    return state.rptRetenciones
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
